import { useState } from 'react';
import Text from '../Text/Text';
import styles from './Button.module.css';

interface ButtonProps {
	text: string;
	onClick?: () => void;
}

export default function Button(props: ButtonProps) {
	const { onClick, text } = props;

	const handleClick = () => {
		!!onClick && onClick();
	};

	return (
		<div onClick={handleClick} className={styles.test}>
			<Text tx={text} />
		</div>
	);
}
